import { AddressData } from './getAddresses'
import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { isEmpty } from '../../../utils/isEmpty'

const ENDPOINT = '/partners/vendors'

export const updateVendorAddressInfo = async (
  data: AddressData,
  verificationState: string
) => {
  const role = Storage().getActiveRole()

  if (isEmpty(role)) return { error: 'no active role' }

  const { patch } = StackAPI()
  const { id } = role

  const params = {
    contact_info_attributes: {
      ...data,
      address_verification_state: verificationState
    }
  }

  const request = {
    path: `${ENDPOINT}/${id}`,
    params
  }

  try {
    const response = await patch(request)
    if (response.status !== 200) {
      return { error: 'bad response' }
    }

    return response.data
  } catch (_error) {
    return { error: 'unknown error' }
  }
}
